<template>
  <div class="upload-list">
    <upload-list-item
      v-for="referenceFile in referenceFiles"
      :key="referenceFile.key"
      :reference-file="referenceFile"
      :downloading="
        downloadingReferenceFileIds.includes(referenceFile.id)
      "
      :processing-duplicates="processingDuplicates"
      :has-uploads-in-progress="uploadsInProgress"
      @download="$emit('download', referenceFile.id)"
      @download-invalid="$emit('download-invalid', referenceFile.id)"
      @re-run-duplicates="$emit('re-run-duplicates')"
    />
  </div>
</template>

<script>
import UploadListItem from '@/components/UploadsPage/UploadListItem';
import { ReferenceFile } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'UploadList',
  components: { UploadListItem },
  props: {
    referenceFiles: {
      type: Array,
      default: () => [],
      validator: typeHelpers.isArrayOfType(ReferenceFile),
    },
    downloadingReferenceFileIds: {
      type: Array,
      default: () => [],
      validator: typeHelpers.isArrayOfType(String),
    },
    processingDuplicates: {
      type: Boolean,
      default: false,
    },
    hasUploadsInProgress: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['download', 'download-invalid', 're-run-duplicates'],
  computed: {
    uploadsInProgress() {
      // Review-wide signal (from UploadGroupList) OR this group's own files:
      // dedup is review-wide, so an earlier group's counts can still change
      // while a different group is processing. The per-group check keeps this
      // correct for any caller that renders a list without the review-wide prop.
      return (
        this.hasUploadsInProgress ||
        this.referenceFiles.some((file) => file.inProgress())
      );
    },
  },
};
</script>

<style scoped>
.upload-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}
</style>
